
import { LoadCase, LoadCombination, StructuralLoad, PointLoad, LineLoad } from './types';

export class LoadManager {

    private loadCases: LoadCase[] = [];
    private loadCombinations: LoadCombination[] = [];
    private loads: StructuralLoad[] = [];

    constructor() {
        // Initialize default cases
        this.createLoadCase('DL1', 'Dead Load 1', 'Dead');
        this.createLoadCase('LL1', 'Live Load 1', 'Live');
    }

    createLoadCase(id: string, name: string, nature: LoadCase['nature']): LoadCase {
        const newCase: LoadCase = {
            id,
            name,
            nature,
            number: this.loadCases.length + 1
        };
        this.loadCases.push(newCase);
        return newCase;
    }

    createLoadCombination(name: string, factors: { caseId: string, factor: number }[]): LoadCombination {
        const combo: LoadCombination = {
            id: crypto.randomUUID(),
            name,
            type: 'Ultimate',
            factors
        };
        this.loadCombinations.push(combo);
        return combo;
    }

    addPointLoad(caseId: string, position: [number, number, number], force: [number, number, number], moment: [number, number, number] = [0, 0, 0]): PointLoad {
        const load: PointLoad = {
            id: crypto.randomUUID(),
            type: 'Structural Loads',
            category: 'Structural Loads',
            loadType: 'Point',
            caseId,
            position,
            forceVector: force,
            momentVector: moment,
            parameters: {},
            constraints: []
        };
        this.loads.push(load);
        return load;
    }

    addLineLoad(caseId: string, start: [number, number, number], end: [number, number, number], force: [number, number, number]): LineLoad {
        const load: LineLoad = {
            id: crypto.randomUUID(),
            type: 'Structural Loads',
            category: 'Structural Loads',
            loadType: 'Line',
            caseId,
            start,
            end,
            isProjected: false,
            forceVector: force,
            momentVector: [0, 0, 0],
            parameters: {},
            constraints: []
        };
        this.loads.push(load);
        return load;
    }

    getLoadsForCase(caseId: string): StructuralLoad[] {
        return this.loads.filter(l => l.caseId === caseId);
    }
}
